<app-account-subform-shell
  titleId="account-change-password-title"
  [crumb]="'Account settings / Security' | translate"
  [title]="'Change password' | translate"
  (back)="cancelled.emit()"
>
  <form class="password-form" novalidate [formGroup]="form" (keydown.enter)="onEnter($event)">
    <div class="field">
      <label class="label" for="account-old-password">{{ 'Current password' | translate }}</label>
      <div class="password-field" [class.password-field-error]="serverErrors.length > 0">
        <input
          id="account-old-password"
          autocomplete="current-password"
          aria-describedby="account-old-password-error"
          [type]="visibleFields.oldPassword ? 'text' : 'password'"
          [formControlName]="fields.oldPassword"
        />
        <button
          type="button"
          class="eye"
          [attr.aria-pressed]="visibleFields.oldPassword"
          [attr.aria-label]="(visibleFields.oldPassword ? 'Hide password' : 'Show password') | translate"
          (click)="toggleVisibility(fields.oldPassword)"
        >
          <app-account-icon [name]="visibleFields.oldPassword ? 'eye-off' : 'eye'"></app-account-icon>
        </button>
      </div>
      @if (serverErrors.length > 0) {
        <div class="field-msg field-msg-error server-error" id="account-old-password-error" role="alert">
          @for (error of serverErrors; track trackByIndex($index)) {
            <span>{{ error }}</span>
          }
        </div>
      }
    </div>

    <div class="field">
      <label class="label" for="account-new-password">{{ 'New password' | translate }}</label>
      <div class="password-field" [class.password-field-error]="newPasswordInvalid">
        <input
          id="account-new-password"
          autocomplete="new-password"
          aria-describedby="account-password-criteria"
          [type]="visibleFields.newPassword ? 'text' : 'password'"
          [formControlName]="fields.newPassword"
        />
        <button
          type="button"
          class="eye"
          [attr.aria-pressed]="visibleFields.newPassword"
          [attr.aria-label]="(visibleFields.newPassword ? 'Hide password' : 'Show password') | translate"
          (click)="toggleVisibility(fields.newPassword)"
        >
          <app-account-icon [name]="visibleFields.newPassword ? 'eye-off' : 'eye'"></app-account-icon>
        </button>
      </div>
    </div>

    <div class="field">
      <label class="label" for="account-confirm-password">{{ 'Confirm new password' | translate }}</label>
      <div class="password-field" [class.password-field-error]="passwordsMismatch">
        <input
          id="account-confirm-password"
          autocomplete="new-password"
          aria-describedby="account-confirm-password-msg"
          [type]="visibleFields.confirmPassword ? 'text' : 'password'"
          [formControlName]="fields.confirmPassword"
        />
        <button
          type="button"
          class="eye"
          [attr.aria-pressed]="visibleFields.confirmPassword"
          [attr.aria-label]="(visibleFields.confirmPassword ? 'Hide password' : 'Show password') | translate"
          (click)="toggleVisibility(fields.confirmPassword)"
        >
          <app-account-icon [name]="visibleFields.confirmPassword ? 'eye-off' : 'eye'"></app-account-icon>
        </button>
      </div>
      <span class="match-msg" id="account-confirm-password-msg" aria-live="polite">
        @if (passwordsMismatch) {
          <span class="field-msg field-msg-error">{{ "Passwords don't match" | translate }}</span>
        } @else if (passwordsMatch) {
          <span class="field-msg field-msg-ok">{{ 'Passwords match' | translate }}</span>
        }
      </span>
    </div>

    <app-password-criteria id="account-password-criteria" [password]="newPassword"></app-password-criteria>
  </form>

  <div subformFooter class="footer-actions">
    <button type="button" class="as-btn-secondary" (click)="cancelled.emit()">
      {{ 'Cancel' | translate }}
    </button>
    <button type="button" class="as-btn-primary update-password" [disabled]="!canSubmit" (click)="submit()">
      {{ 'Update password' | translate }}
    </button>
  </div>
</app-account-subform-shell>
